/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckCircleSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 56 57" {...props}>
    <path
      fill="#C5F2E0"
      d="M0 28.5C0 13.036 12.536.5 28 .5s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28Z"
    />
    <path
      fill="#075A39"
      d="m24.666 33.785 15.32-15.321 2.358 2.357-17.678 17.678L14.06 27.892l2.357-2.357 8.25 8.25Z"
    />
  </svg>
);

export default SvgCheckCircleSuccess;
